'use strict';

angular.module('app').directive('difficultyLevel', ['$compile', function($compile) {

    var link = function(scope, element, attrs, controller) {
        scope.$watch('ratingValue', function()  {
            var n = Math.round(parseFloat(scope.ratingValue)),
                template = '<div class="diff-level"><ul>',
                level;

            for (var i = 1; i <= 5; i++) {
                if (i <= n) {
                    template += '<li><span class="star-icon-active font-icons"></span></li>';
                }
            }


            if (n > 0 && n < 3) {
                level = 'Low';
            } else if (n == 3) {
                level = 'Medium';
            } else if (n == 4) {
                level = 'High';
            } else {
                level = 'Extreme';
            }

            template += '</ul><p>' + level + '</p></div>';

            var contentTr = $compile(template)(scope);
            element.append(contentTr);
        });
    };

    return {
        restrict: 'AE',
        replace: true,
        scope: {
            ratingValue: '='
        },
        link: link
    };
}]);